// «Как добраться до старта»: первая точка трека ([lon, lat, ele]) - координаты
// для копирования. Координаты - 6 знаков (~10 см).
export const startDirections = (coords: number[][] | undefined) => {
  const p = coords?.[0];
  if (!p) return null;
  const lat = Number(p[1].toFixed(6));
  const lon = Number(p[0].toFixed(6));
  return { lat, lon, label: `${lat}, ${lon}` };
};
